import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69e549ff8485e200144b3c2b/teachglobal/src/app/not-found.tsx");
